<template>
    <div>
        <div class="content">
            <div class="full">
                <div class="full">
                    <div class="subheader">
                        {{ $tc('pages.employeeContext.planning', 2) }}
                    </div>
                </div>
                <div class="full split">
                    <div class="full">
                        <div class="threefourths" style="margin-top: 8px;">
                            <div class="label" style="text-align: left;">
                                {{ $t('store.templates.planningHelp1') }} + {{
                                    storeSettings.country == 1 ?
                                        $t('store.templates.planningCollective') : $t('store.templates.planningModelContract')
                                }} +
                                {{ $t('store.templates.planningHelp2') }}
                            </div>
                        </div>
                    </div>
                    <div class="tenth">
                        <div class="header">
                            <div class="label">{{ $t('store.templates.actions') }}</div>
                        </div>
                    </div>
                    <div class="twotenths">
                        <div class="header">
                            <div class="label">{{ $t('pages.employeeData.name') }}</div>
                        </div>
                    </div>
                    <div class="tenth">
                        <div class="header">
                            <div class="label">
                                {{ (storeSettings.country == 1 ? 'KV' : $t('pages.employeeContract.contractModel')) }}
                                gebunden
                            </div>
                        </div>
                    </div>
                </div>
                <div v-for="t in visibleTemplates" v-bind:key="t.id" class="full h34 split-bottom-tight">
                    <div class="tenth left">
                        <button class="pill info-bg" @click="openViewPopup(t.id)">
                            <i class="fas fa-info" style="margin-left: -1px;"></i>
                        </button>
                        <button class="pill warn-bg ml5" @click="openEditPopup(t.id)">
                            <i class="fas fa-edit" style="margin-left: -1px;"></i>
                        </button>
                        <button class="pill danger-bg ml5" @click="openDeletePopup(t)">
                            <i class="fas fa-trash" style="margin-left: -1px;"></i>
                        </button>
                    </div>
                    <div class="twotenths">
                        <div class="label">{{ t.name }}</div>
                    </div>
                    <div class="tenth">
                        <div class="label"><i
                            v-bind:class="{'fas fa-check': t.contractId != null, 'fas fa-times': t.contractId == null}"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
    name: 'storeplanningguidelinesemployeetype',
    props: {
        displayInactiveConctractTemplates: Boolean
    },
    data() {
        return {


            fields: [{
                key: "name",
                label: this.$t('pages.employeeData.name'),
                thClass: 'documentsTh',
                tdClass: 'documentsTd'
            }, {
                key: "actions",
                label: "",
                thClass: 'documentsTh',
                tdClass: 'documentsTd',
                sortable: false
            }],
            templateId: "",
            contractId: null,
            currentTemplateRow: undefined,
            employeeTypeTemplate: {
                name: "",
                contractId: null,
                monthTimeMaxType: 1,
                monthTimeMaxAdjustmentMin: 0,
                monthTimeMaxAdjustmentMax: 0,
                weekTimeMaxMin: 60*60,
                weekTimeMaxMax: 60*60,
                weekTimeRegularMin: 40*60,
                weekTimeRegularMax: 40*60,
                dayTimeMaxMin: 12*60,
                dayTimeMaxMax: 12*60,
                dayTimeRegularMin: 8*60,
                dayTimeRegularMax: 8*60,
                restTimeMin: 11*60,
                restTimeMax: 11*60,
                allowMultipleShifts: false,
                shiftBetweenTimeMinMin: 0,
                shiftBetweenTimeMinMax: 0,
                shiftBetweenTimeMaxMin: 3*60,
                shiftBetweenTimeMaxMax: 3*60,
                limitConsecutiveDays: false,
                daysConsecutiveMaxMin: 6,
                daysConsecutiveMaxMax: 6,
                limitOvertime: false,
                monthOvertimeMaxMin: 20*60,
                monthOvertimeMaxMax: 20*60,
                overtimeCutoffMin: 480,
                overtimeCutoffMax: 480,
                useWorkDaysForSpareTime: false,
                weekWorkDaysMaxMin: 1,
                weekWorkDaysMaxMax: 1,
                weekWorkDaysRegularMin: 5,
                weekWorkDaysRegularMax: 5,
                weekSpareDaysMinMin: 1,
                weekSpareDaysMinMax: 1,
                weekAdditionalSpareTime: 12*60,
                weekTimeAvgType: 1,
                weekSpareTimeStartType: 1,
                weekSpareTimeStartMin: null,
                weekSpareTimeStartMax: null,
                limitEmployeeCount: false,
                employeeCountMax: null
            },
            templateLimits: {
                disableMonthTimeMaxType: false,
                monthTimeRegularMinLimit: 0*60,
                monthTimeRegularMaxLimit: 372*60,
                disableMonthTimeRegular: false,
                monthTimeMaxAdjustmentMinLimit: -372*60,
                monthTimeMaxAdjustmentMaxLimit: 372*60,
                disableMonthTimeMaxAdjustment: false,
                weekTimeRegularMinLimit: 1*60,
                weekTimeRegularMaxLimit: 168*60,
                disableWeekTimeRegular: false,
                weekTimeMaxMinLimit: 0*60,
                weekTimeMaxMaxLimit: 168*60,
                disableWeekTimeMax: false,
                disableWeekTimeAvgType: false,
                dayTimeRegularMinLimit: 0*60,
                dayTimeRegularMaxLimit: 24*60,
                disableDayTimeRegular: false,
                dayTimeMaxMinLimit: 0*60,
                dayTimeMaxMaxLimit: 24*60,
                disableDayTimeMax: false,
                weekWorkDaysRegularMinLimit: 0,
                weekWorkDaysRegularMaxLimit: 7,
                disableWeekWorkDaysRegular: false,
                restTimeMinLimit: 0*60,
                restTimeMaxLimit: 24*60,
                disableRestTime: false,
                weekSpareDaysMinMinLimit: 0,
                weekSpareDaysMinMaxLimit: 7,
                disableweekSpareDaysMin: false,
                weekAdditionalSpareTimeMinLimit: 0,
                weekAdditionalSpareTimeMaxLimit: 48*60,
                disableWeekAdditionalSpareTime: false,

            },
            templateerror: false,
        }
    },
    created: function () {
        if (this.$store.state.jwt != undefined && this.$store.state.storeId != undefined) {
            this.refresh();
        }
    },
    computed: {
        ...mapGetters(['storeId', 'employeeTypeTemplateMap', 'collectiveContractMap', 'allowedContractMap', 'storeSettings']),
        monthTimeRegularMin() {
            return Math.round(this.employeeTypeTemplate.weekTimeRegularMin * 4.325);
        },
        monthTimeRegularMax() {
            return Math.round(this.employeeTypeTemplate.weekTimeRegularMax * 4.325);
        },
        visibleTemplates() {
            return Object.values(this.employeeTypeTemplateMap)
                .filter(t => this.displayInactiveConctractTemplates || t.contractId == null || this.allowedContractMap[t.contractId].active)
                .sort((a, b) => {
                    let res = b.weekTimeRegularMax - a.weekTimeRegularMax;
                    if(res == 0){
                        res = b.weekWorkDaysRegularMax - a.weekWorkDaysRegularMax ;
                    }
                    return res;
                });
        },
    },
    watch: {
        storeId(newVal, oldVal){
            this.refresh();
        }
    },
    // methods that implement data logic.
    methods: {
        loadingStart(){
            this.$emit('update-loading-state', true);
        },
        loadingStop(){
            this.$emit('update-loading-state', false);
        },
        refresh: function () {
            let view = this;
            view.loadingStart();
            this.$helpers.GetCollectiveContractMap()
                .then(response => {
                    return view.$helpers.GetAllowedContractMap();
                }).then(response => {
                return view.$helpers.GetEmployeeTypeTemplateMap();
            }).then(response => {
                view.loadingStop();
            }).catch(function (error) {
                view.loadingStop();
                console.log(error)
            })

        },
        onChangeContract: function (val) {
            this.setEmployeeTypeTemplateValues(val);
            this.setContractLimits(val);

        },
        openViewPopup(templateId){
            this.fillEmployeeTypeTemplateForPopup(templateId);
            this.openDetailPopup(true, false);
        },
        openCreatePopup(){
            this.employeeTypeTemplate = {
                name: "",
                contractId: null,
                monthTimeMaxType: 1,
                monthTimeMaxAdjustmentMin: 0,
                monthTimeMaxAdjustmentMax: 0,
                weekTimeMaxMin: 60*60,
                weekTimeMaxMax: 60*60,
                weekTimeRegularMin: 40*60,
                weekTimeRegularMax: 40*60,
                dayTimeMaxMin: 12*60,
                dayTimeMaxMax: 12*60,
                dayTimeRegularMin: 8*60,
                dayTimeRegularMax: 8*60,
                restTimeMin: 11*60,
                restTimeMax: 11*60,
                allowMultipleShifts: false,
                shiftBetweenTimeMinMin: 0*60,
                shiftBetweenTimeMinMax: 0*60,
                shiftBetweenTimeMaxMin: 3*60,
                shiftBetweenTimeMaxMax: 3*60,
                limitConsecutiveDays: false,
                daysConsecutiveMaxMin: 6,
                daysConsecutiveMaxMax: 6,
                limitOvertime: false,
                monthOvertimeMaxMin: 20*60,
                monthOvertimeMaxMax: 20*60,
                overtimeCutoffMin: 480,
                overtimeCutoffMax: 480,
                useWorkDaysForSpareTime: false,
                weekWorkDaysMaxMin: 1,
                weekWorkDaysMaxMax: 1,
                weekWorkDaysRegularMin: 5,
                weekWorkDaysRegularMax: 5,
                weekSpareDaysMinMin: 1,
                weekSpareDaysMinMax: 1,
                weekAdditionalSpareTime: 12*60,
                weekTimeAvgType: 1,
                weekSpareTimeStartType: 1,
                weekSpareTimeStartMin: null,
                weekSpareTimeStartMax: null,
                limitEmployeeCount: false,
                employeeCountMax: null
            };
            this.templateLimits = {
                disableMonthTimeMaxType: false,
                monthTimeRegularMinLimit: 0*60,
                monthTimeRegularMaxLimit: 372*60,
                disableMonthTimeRegular: false,
                monthTimeMaxAdjustmentMinLimit: -372*60,
                monthTimeMaxAdjustmentMaxLimit: 372*60,
                disableMonthTimeMaxAdjustment: false,
                weekTimeRegularMinLimit: 0*60,
                weekTimeRegularMaxLimit: 168*60,
                disableWeekTimeRegular: false,
                weekTimeMaxMinLimit: 0*60,
                weekTimeMaxMaxLimit: 168*60,
                disableWeekTimeMax: false,
                disableWeekTimeAvgType: false,
                dayTimeRegularMinLimit: 0*60,
                dayTimeRegularMaxLimit: 24*60,
                disableDayTimeRegular: false,
                dayTimeMaxMinLimit: 0*60,
                dayTimeMaxMaxLimit: 24*60,
                disableDayTimeMax: false,
                weekWorkDaysRegularMinLimit: 0,
                weekWorkDaysRegularMaxLimit: 7,
                disableWeekWorkDaysRegular: false,
                restTimeMinLimit: 0*60,
                restTimeMaxLimit: 24*60,
                disableRestTime: false,
                weekSpareDaysMinMinLimit: 0,
                weekSpareDaysMinMaxLimit: 7,
                disableweekSpareDaysMin: false,
                weekAdditionalSpareTimeMinLimit: 0*60,
                weekAdditionalSpareTimeMaxLimit: 48*60,
                disableWeekAdditionalSpareTime: false,

            };
            let time1 = this.$helpers.getMomentTZ().clone().hours(8).minutes(0);
            let time2 = this.$helpers.getMomentTZ().clone().hours(16).minutes(0);
            this.employeeTypeTemplate.weekSpareTimeStartMin = time1;
            this.employeeTypeTemplate.weekSpareTimeStartMax = time2;
            this.openDetailPopup(false);
        },
        openEditPopup(templateId){
            this.fillEmployeeTypeTemplateForPopup(templateId);
            this.openDetailPopup(false, true);
        },
        fillEmployeeTypeTemplateForPopup(templateId){
            this.templateId = templateId;
            let templateMapItem = this.employeeTypeTemplateMap[this.templateId];
            this.employeeTypeTemplate = {
                name: templateMapItem.name,
                contractId: templateMapItem.contractId,
                monthTimeMaxType: templateMapItem.monthTimeMaxType,
                monthTimeMaxAdjustmentMin: templateMapItem.monthTimeMaxAdjustmentMin,
                monthTimeMaxAdjustmentMax: templateMapItem.monthTimeMaxAdjustmentMax,
                weekTimeMaxMin: templateMapItem.weekTimeMaxMin,
                weekTimeMaxMax: templateMapItem.weekTimeMaxMax,
                weekTimeRegularMin: templateMapItem.weekTimeRegularMin,
                weekTimeRegularMax: templateMapItem.weekTimeRegularMax,
                dayTimeMaxMin: templateMapItem.dayTimeMaxMin,
                dayTimeMaxMax: templateMapItem.dayTimeMaxMax,
                dayTimeRegularMin: templateMapItem.dayTimeRegularMin,
                dayTimeRegularMax: templateMapItem.dayTimeRegularMax,
                restTimeMin: templateMapItem.restTimeMin,
                restTimeMax: templateMapItem.restTimeMax,
                shiftBetweenTimeMinMin: templateMapItem.shiftBetweenTimeMinMin,
                shiftBetweenTimeMinMax: templateMapItem.shiftBetweenTimeMinMax,
                shiftBetweenTimeMaxMin: templateMapItem.shiftBetweenTimeMaxMin,
                shiftBetweenTimeMaxMax: templateMapItem.shiftBetweenTimeMaxMax,
                daysConsecutiveMaxMin: templateMapItem.daysConsecutiveMaxMin,
                daysConsecutiveMaxMax: templateMapItem.daysConsecutiveMaxMax,
                monthOvertimeMaxMin: templateMapItem.monthOvertimeMaxMin,
                monthOvertimeMaxMax: templateMapItem.monthOvertimeMaxMax,
                overtimeCutoffMin: templateMapItem.overtimeCutoffMin,
                overtimeCutoffMax: templateMapItem.overtimeCutoffMax,
                weekWorkDaysMaxMin: templateMapItem.weekWorkDaysMaxMin,
                weekWorkDaysMaxMax: templateMapItem.weekWorkDaysMaxMax,
                weekWorkDaysRegularMin: templateMapItem.weekWorkDaysRegularMin,
                weekWorkDaysRegularMax: templateMapItem.weekWorkDaysRegularMax,
                weekSpareDaysMinMin: templateMapItem.weekSpareDaysMinMin,
                weekSpareDaysMinMax: templateMapItem.weekSpareDaysMinMax,
                weekAdditionalSpareTime: (templateMapItem.weekSpareTimeMinMin) - (templateMapItem.weekSpareDaysMinMin * 24 * 60),
                weekTimeAvgType: templateMapItem.weekTimeAvgType,
                allowMultipleShifts: false,
                limitConsecutiveDays: false,
                limitOvertime: false,
                useWorkDaysForSpareTime: false,
                weekSpareTimeStartType: templateMapItem.weekSpareTimeStartType,
                weekSpareTimeStartMin: this.$helpers.extractTimeString(templateMapItem.weekSpareTimeStartMin),
                weekSpareTimeStartMax: this.$helpers.extractTimeString(templateMapItem.weekSpareTimeStartMax),
                limitEmployeeCount: false,
                employeeCountMax: templateMapItem.employeeCountMax
            }
            if (this.employeeTypeTemplate.employeeCountMax != null) {
                this.employeeTypeTemplate.limitEmployeeCount = true;
            }

            if (this.employeeTypeTemplate.shiftBetweenTimeMinMin > -1) {

                this.employeeTypeTemplate.shiftBetweenTimeMinMin = this.employeeTypeTemplate.shiftBetweenTimeMinMin;
                this.employeeTypeTemplate.shiftBetweenTimeMinMax = this.employeeTypeTemplate.shiftBetweenTimeMinMax;
                this.employeeTypeTemplate.shiftBetweenTimeMaxMin = this.employeeTypeTemplate.shiftBetweenTimeMaxMin;
                this.employeeTypeTemplate.shiftBetweenTimeMaxMax = this.employeeTypeTemplate.shiftBetweenTimeMaxMax;
                this.employeeTypeTemplate.allowMultipleShifts = true;
            } else {

                this.employeeTypeTemplate.allowMultipleShifts = false;
            }

            if (this.employeeTypeTemplate.daysConsecutiveMaxMin > -1) {
                this.employeeTypeTemplate.limitConsecutiveDays = true;
            } else {
                this.employeeTypeTemplate.limitConsecutiveDays = false;
            }

            if (this.employeeTypeTemplate.monthOvertimeMaxMin > -1) {
                this.employeeTypeTemplate.monthOvertimeMaxMin = this.employeeTypeTemplate.monthOvertimeMaxMin;
                this.employeeTypeTemplate.monthOvertimeMaxMax = this.employeeTypeTemplate.monthOvertimeMaxMax;
                this.employeeTypeTemplate.limitOvertime = true;
            } else {
                this.employeeTypeTemplate.limitOvertime = false;
            }

            if (this.employeeTypeTemplate.weekWorkDaysMaxMin > -1) {
                this.employeeTypeTemplate.useWorkDaysForSpareTime = true;
            } else {
                this.employeeTypeTemplate.useWorkDaysForSpareTime = false;
            }

            if(!this.employeeTypeTemplate.weekSpareTimeStartMin){
                let time1 = this.$helpers.getMomentUTC().clone().hours(8).minutes(0);
                this.employeeTypeTemplate.weekSpareTimeStartMin = time1;
            } else {
                let time1 = this.$helpers.getMomentFromStringUTC(this.employeeTypeTemplate.weekSpareTimeStartMin, "HH:mm");
                this.employeeTypeTemplate.weekSpareTimeStartMin = time1;
            }
            if(!this.employeeTypeTemplate.weekSpareTimeStartMax){
                let time2 = this.$helpers.getMomentUTC().clone().hours(16).minutes(0);
                this.employeeTypeTemplate.weekSpareTimeStartMax = time2;
            } else {
                let time2 = this.$helpers.getMomentFromStringUTC(this.employeeTypeTemplate.weekSpareTimeStartMax, "HH:mm");
                this.employeeTypeTemplate.weekSpareTimeStartMax = time2;
            }
            this.setContractLimits(this.employeeTypeTemplate.contractId);
        },
        dividerOrFlat(hiddenVars){
            var flat = true;
            hiddenVars.forEach(v => { if(!v) flat = false; })
            return {divider: !flat, flat: flat};
        },
        openDetailPopup(readonly = false, edit = false){
            let view = this;
            var ccId = this.employeeTypeTemplate.contractId;
            let contract;
            let allowedContract;
            if(ccId){
                allowedContract = this.allowedContractMap[ccId];
                contract = this.collectiveContractMap[allowedContract.collectiveContractId];
            }

            let allowedContracts = [];
            Object.values(this.allowedContractMap).forEach(c => {
                /*let cContract = this.collectiveContractMap[c.collectiveContractId];
                if(cContract){
                    let item = {id: cContract.id, value: cContract.id, label: cContract.name};
                    collectiveContracts.push(item);
                } */
                let item = {id: c.id, value: c.id, label: view.collectiveContractMap[c.collectiveContractId].name +" "+(c.weekTimeRegular/60).toFixed(2)+"h / "+c.weekWorkDaysRegular+"T"};
                allowedContracts.push(item);
            });

            let selectedAllowedContract = {};
            if(allowedContract){
                selectedAllowedContract = allowedContracts.find(i => i.id == allowedContract.id);
            }

            var monthTimeMaxTypes = [
                {id: 1, value: 1, label: view.$t('store.templates.exceedTargetHours')},
                {id: 2, value: 2, label: view.$t('store.templates.exceedTargetHoursLimited')},
                {id: 3, value: 3, label: view.$t('store.templates.dontExceedTargetHours')}
            ];
            if(contract){
                //remove all monthTimeMaxTypes that are below threshold
                monthTimeMaxTypes = monthTimeMaxTypes.filter(t => t.value >= contract.monthTimeMaxType);
            }
            var weekTimeAvgTypes = [
                {id: 1, value: 1, label: view.$t('store.templates.ignoreWeeklyAverage')},
                {id: 2, value: 2, label: view.$t('store.templates.approximateWeeklyAverage')},
                {id: 3, value: 3, label: view.$t('store.templates.strictWeeklyAverage')}
            ];
            if(contract){
                //remove all monthTimeMaxTypes that are below threshold
                weekTimeAvgTypes = weekTimeAvgTypes.filter(t => t.value >= contract.weekTimeAvgType);
            }
            var weekSpareTimeStartTypes = [
                {id: 1, value: 1, label: view.$t('store.templates.freelyFreeTime')},
                {id: 2, value: 2, label: view.$t('store.templates.targetFreeTime')},
                {id: 3, value: 3, label: view.$t('store.templates.strictFreeTime')}
            ];
            var selectedMonthTimeMaxType = {};
            if(view.employeeTypeTemplate.monthTimeMaxType > 0){
                selectedMonthTimeMaxType = monthTimeMaxTypes.find(t => t.value == view.employeeTypeTemplate.monthTimeMaxType );
            }
            var selectedWeekTimeAvgType = {};
            if(view.employeeTypeTemplate.weekTimeAvgType > 0){
                selectedWeekTimeAvgType = weekTimeAvgTypes.find(t => t.value == view.employeeTypeTemplate.weekTimeAvgType);
            }
            var selectedWeekSpareTimeStartType = {};
            if(view.employeeTypeTemplate.weekSpareTimeStartType > 0){
                selectedWeekSpareTimeStartType = weekSpareTimeStartTypes.find(t => t.value == view.employeeTypeTemplate.weekSpareTimeStartType);
            }

            let weekTimeRegularMinHidden = !readonly && contract != null? view.templateLimits.disableWeekTimeRegular : false;
            let weekTimeRegularMaxHidden = !readonly && contract != null? view.templateLimits.disableWeekTimeRegular : false;
            let monthTimeMaxTypeHidden = !readonly && contract != null? view.templateLimits.disableMonthTimeMaxType : false;
            let monthTimeMaxAdjustmentMinHidden = !readonly && contract != null? view.templateLimits.disableMonthTimeMaxAdjustment : false;
            let monthTimeMaxAdjustmentMaxHidden = !readonly && contract != null? view.templateLimits.disableMonthTimeMaxAdjustment : false;
            let weekTimeMaxMinHidden = !readonly && contract != null? view.templateLimits.disableWeekTimeMax : false;
            let weekTimeMaxMaxHidden = !readonly && contract != null? view.templateLimits.disableWeekTimeMax : false;
            let weekTimeAvgTypeHidden = !readonly && contract != null? view.templateLimits.disableWeekTimeAvgType : false;
            let weekWorkDaysRegularMinHidden = !readonly && contract != null? view.templateLimits.disableWeekWorkDaysRegularMin || view.templateLimits.weekWorkDaysRegularMinLimit == view.templateLimits.weekWorkDaysRegularMaxLimit : false;
            let weekWorkDaysRegularMaxHidden = !readonly && contract != null? view.templateLimits.disableWeekWorkDaysRegularMax || view.templateLimits.weekWorkDaysRegularMinLimit == view.templateLimits.weekWorkDaysRegularMaxLimit : false;
            let dayTimeRegularMinHidden = !readonly && contract != null? view.templateLimits.disableDayTimeRegular : false;
            let dayTimeRegularMaxHidden = !readonly && contract != null? view.templateLimits.disableDayTimeRegular : false;
            let dayTimeMaxMinHidden = !readonly && contract != null? view.templateLimits.disableDayTimeMax : false;
            let dayTimeMaxMaxHidden = !readonly && contract != null? view.templateLimits.disableDayTimeMax : false;
            let restTimeMinHidden = !readonly && contract != null? view.templateLimits.disableRestTime : false;
            let restTimeMaxHidden = !readonly && contract != null? view.templateLimits.disableRestTime : false;
            let weekSpareDaysMinMinHidden = !readonly && contract != null? view.templateLimits.disableWeekSpareDaysMin : false;
            let weekSpareDaysMinMaxHidden = !readonly && contract != null? view.templateLimits.disableWeekSpareDaysMin : false;
            let weekAdditionalSpareTimeHidden = !readonly && contract != null? view.templateLimits.disableWeekAdditionalSpareTime : false;

            let dataEntries = [
                {
                    label: view.$t('pages.employeeData.name') + ': ',
                    key: 'name',
                    uxdisabled: readonly,
                    hidden: false,
                    type: 'text',
                    value: view.employeeTypeTemplate.name,
                    length: 128,
                    styles: {
                        'width': '600px'
                    },
                    labelStyles: {
                        'font-family': 'DistrictProBold'
                    }
                },
                {
                    divider: true
                },
                {
                    label: view.$t('store.templates.weekTargetMin') + ': ',
                    key: 'weekTimeRegularMin',
                    uxdisabled: readonly,
                    hidden: weekTimeRegularMinHidden,
                    disabled: readonly? false : view.templateLimits.disableWeekTimeRegular,
                    type: 'slider',
                    value: view.employeeTypeTemplate.weekTimeRegularMin,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let weekTimeRegularMax = datafill.entries.find(i => i.key == 'weekTimeRegularMax').value;
                        let slider = entryBeforeUpdate.slider;
                        slider.max = weekTimeRegularMax;
                        slider.value = Math.min(slider.value, weekTimeRegularMax)
                        let newSlider = Object.assign({}, slider)
                        entryBeforeUpdate.slider = newSlider;
                        entryBeforeUpdate.value = newSlider.value;
                        return entryBeforeUpdate;
                    },
                    slider: {
                        min: view.templateLimits.weekTimeRegularMinLimit,
                        max: view.employeeTypeTemplate.weekTimeRegularMax,
                        value: view.employeeTypeTemplate.weekTimeRegularMin,
                        step: 15,
                        DisplayLabel: (val) => {return val / 60},
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x * 60 },
                    }
                },
                {
                    label: view.$t('store.templates.weekTargetMax') + ': ',
                    key: 'weekTimeRegularMax',
                    uxdisabled: readonly,
                    hidden: weekTimeRegularMaxHidden,
                    disabled: readonly? false : view.templateLimits.disableWeekTimeRegular,
                    type: 'slider',
                    value: view.employeeTypeTemplate.weekTimeRegularMax,
                    slider: {
                        min: view.templateLimits.weekTimeRegularMinLimit,
                        max: view.templateLimits.weekTimeRegularMaxLimit,
                        value: view.employeeTypeTemplate.weekTimeRegularMax,
                        step: 15,
                        DisplayLabel: (val) => {return val / 60},
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x * 60 },
                    }
                },
                view.dividerOrFlat([weekTimeRegularMinHidden, weekTimeRegularMaxHidden]),
                {key: 'monthTimeMaxType', disabled: readonly? false : view.templateLimits.disableMonthTimeMaxType, uxdisabled: readonly, hidden: monthTimeMaxTypeHidden, type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: true, dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: monthTimeMaxTypes,
                        selectMultiple: false,
                        selectedItems: [selectedMonthTimeMaxType],
                        selectedItem: selectedMonthTimeMaxType,
                        onceSelected: function ($event, item, searchbar){
                        },
                        styleLight: true,
                        placeholder: view.$t('store.settings.monthTargetHoursOverrun'),
                    }, styles: {width: '600px'}},
                {
                    label: view.$t('store.settings.monthTargetBufferMin') + ': ',
                    key: 'monthTimeMaxAdjustmentMin',
                    uxdisabled: readonly,
                    hidden: monthTimeMaxAdjustmentMinHidden,
                    disabled: readonly? false : view.templateLimits.disableMonthTimeMaxAdjustment,
                    hiddenBoundToValueInverse: {key: 'monthTimeMaxType', value: 2},
                    type: 'slider',
                    value: view.employeeTypeTemplate.monthTimeMaxAdjustmentMin,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let max = datafill.entries.find(i => i.key == 'monthTimeMaxAdjustmentMax').value;
                        let slider = entryBeforeUpdate.slider;
                        slider.max = max;
                        slider.value = Math.min(slider.value, max)
                        let newSlider = Object.assign({}, slider)
                        entryBeforeUpdate.slider = newSlider;
                        entryBeforeUpdate.value = newSlider.value;
                        return entryBeforeUpdate;
                    },
                    slider: {
                        min: view.templateLimits.monthTimeMaxAdjustmentMinLimit,
                        max: view.employeeTypeTemplate.monthTimeMaxAdjustmentMax,
                        value: view.employeeTypeTemplate.monthTimeMaxAdjustmentMin,
                        step: 60,
                        DisplayLabel: (val) => {return val / 60},
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x * 60 },
                    }
                },
                {
                    label: view.$t('store.settings.monthTargetBufferMax') + ': ',
                    key: 'monthTimeMaxAdjustmentMax',
                    uxdisabled: readonly,
                    hidden: monthTimeMaxAdjustmentMaxHidden,
                    disabled: readonly? false : view.templateLimits.disableMonthTimeMaxAdjustment,
                    hiddenBoundToValueInverse: {key: 'monthTimeMaxType', value: 2},
                    type: 'slider',
                    value: view.employeeTypeTemplate.monthTimeMaxAdjustmentMax,
                    slider: {
                        min: view.templateLimits.monthTimeMaxAdjustmentMinLimit,
                        max: view.templateLimits.monthTimeMaxAdjustmentMaxLimit,
                        value: view.employeeTypeTemplate.monthTimeMaxAdjustmentMax,
                        step: 60,
                        DisplayLabel: (val) => {return val / 60},
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x * 60 },
                    }
                },
                view.dividerOrFlat([monthTimeMaxTypeHidden, monthTimeMaxAdjustmentMinHidden, monthTimeMaxAdjustmentMaxHidden]),
                {
                    label: view.$t('store.templates.maxWeekRangeMin') + ': ',
                    key: 'weekTimeMaxMin',
                    uxdisabled: readonly,
                    hidden: weekTimeMaxMinHidden,
                    disabled: readonly? false : view.templateLimits.disableWeekTimeMax,
                    type: 'slider',
                    value: view.employeeTypeTemplate.weekTimeMaxMin,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let max = datafill.entries.find(i => i.key == 'weekTimeMaxMax').value;
                        let slider = entryBeforeUpdate.slider;
                        slider.max = max;
                        slider.value = Math.min(slider.value, max)
                        let newSlider = Object.assign({}, slider)
                        entryBeforeUpdate.slider = newSlider;
                        entryBeforeUpdate.value = newSlider.value;
                        return entryBeforeUpdate;
                    },
                    slider: {
                        min: view.templateLimits.weekTimeMaxMinLimit,
                        max: view.employeeTypeTemplate.weekTimeMaxMax,
                        value: view.employeeTypeTemplate.weekTimeMaxMin,
                        step: 15,
                        DisplayLabel: (val) => {return val / 60},
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x * 60 },
                    }
                },
                {
                    label: view.$t('store.templates.maxWeekRangeMax') + ': ',
                    key: 'weekTimeMaxMax',
                    uxdisabled: readonly,
                    hidden: weekTimeMaxMaxHidden,
                    disabled: readonly? false : view.templateLimits.disableWeekTimeMax,
                    type: 'slider',
                    value: view.employeeTypeTemplate.weekTimeMaxMax,
                    slider: {
                        min: view.templateLimits.weekTimeMaxMinLimit,
                        max: view.templateLimits.weekTimeMaxMaxLimit,
                        value: view.employeeTypeTemplate.weekTimeMaxMax,
                        step: 15,
                        DisplayLabel: (val) => {return val / 60},
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x * 60 },
                    }
                },
                {key: 'weekTimeAvgType', disabled: readonly? false : view.templateLimits.disableWeekTimeAvgType, uxdisabled: readonly, hidden: weekTimeAvgTypeHidden, type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: true, dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: weekTimeAvgTypes,
                        selectMultiple: false,
                        selectedItems: [],
                        selectedItem: selectedWeekTimeAvgType,
                        onceSelected: function ($event, item, searchbar){
                        },
                        styleLight: true,
                        placeholder: view.$t('store.settings.considerWeeklyAverage'),
                    }, styles: {width: '600px'}},
                view.dividerOrFlat([weekTimeMaxMinHidden, weekTimeMaxMaxHidden, weekTimeAvgTypeHidden]),
                {
                    label: view.$t('store.templates.workDaysWeekMin') + ': ',
                    key: 'weekWorkDaysRegularMin',
                    uxdisabled: readonly,
                    hidden: weekWorkDaysRegularMinHidden,
                    disabled: readonly? false : view.templateLimits.disableWeekWorkDaysRegularMin,
                    type: 'slider',
                    value: view.employeeTypeTemplate.weekWorkDaysRegularMin,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let max = datafill.entries.find(i => i.key == 'weekWorkDaysRegularMax').value;
                        let slider = entryBeforeUpdate.slider;
                        slider.max = max;
                        slider.value = Math.min(slider.value, max)
                        let newSlider = Object.assign({}, slider)
                        entryBeforeUpdate.slider = newSlider;
                        entryBeforeUpdate.value = newSlider.value;
                        return entryBeforeUpdate;
                    },
                    slider: {
                        min: view.templateLimits.weekWorkDaysRegularMinLimit,
                        max: view.employeeTypeTemplate.weekWorkDaysRegularMax,
                        value: view.employeeTypeTemplate.weekWorkDaysRegularMin,
                        step: 1,
                        DisplayLabel: (val) => {return val },
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {
                    label: view.$t('store.templates.workDaysWeekMax') + ': ',
                    key: 'weekWorkDaysRegularMax',
                    uxdisabled: readonly,
                    hidden: weekWorkDaysRegularMaxHidden,
                    disabled: readonly? false : view.templateLimits.disableWeekWorkDaysRegularMax,
                    type: 'slider',
                    value: view.employeeTypeTemplate.weekWorkDaysRegularMax,
                    slider: {
                        min: view.templateLimits.weekWorkDaysRegularMinLimit,
                        max: view.templateLimits.weekWorkDaysRegularMaxLimit,
                        value: view.employeeTypeTemplate.weekWorkDaysRegularMax,
                        step: 1,
                        DisplayLabel: (val) => {return val},
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                view.dividerOrFlat([weekWorkDaysRegularMinHidden, weekWorkDaysRegularMaxHidden]),
                {
                    label: view.$t('store.templates.targetHoursDayMin') + ': ',
                    key: 'dayTimeRegularMin',
                    uxdisabled: readonly,
                    hidden: dayTimeRegularMinHidden,
                    disabled: readonly? false : view.templateLimits.disableDayTimeRegular,
                    type: 'slider',
                    value: view.employeeTypeTemplate.dayTimeRegularMin,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let max = datafill.entries.find(i => i.key == 'dayTimeRegularMax').value;
                        let slider = entryBeforeUpdate.slider;
                        slider.max = max;
                        slider.value = Math.min(slider.value, max)
                        let newSlider = Object.assign({}, slider)
                        entryBeforeUpdate.slider = newSlider;
                        entryBeforeUpdate.value = newSlider.value;
                        return entryBeforeUpdate;
                    },
                    slider: {
                        min: view.templateLimits.dayTimeRegularMinLimit,
                        max: view.employeeTypeTemplate.dayTimeRegularMax,
                        value: view.employeeTypeTemplate.dayTimeRegularMin,
                        step: 15,
                        DisplayLabel: (val) => {return val / 60},
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x * 60 },
                    }
                },
                {
                    label: view.$t('store.templates.targetHoursDayMax') + ': ',
                    key: 'dayTimeRegularMax',
                    uxdisabled: readonly,
                    hidden: dayTimeRegularMaxHidden,
                    disabled: readonly? false : view.templateLimits.disableDayTimeRegular,
                    type: 'slider',
                    value: view.employeeTypeTemplate.dayTimeRegularMax,
                    slider: {
                        min: view.templateLimits.dayTimeRegularMinLimit,
                        max: view.templateLimits.dayTimeRegularMaxLimit,
                        value: view.employeeTypeTemplate.dayTimeRegularMax,
                        step: 15,
                        DisplayLabel: (val) => {return val / 60},
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x * 60 },
                    }
                },
                view.dividerOrFlat([dayTimeRegularMinHidden, dayTimeRegularMaxHidden]),
                {
                    label: view.$t('store.templates.maxHoursDayMin') + ': ',
                    key: 'dayTimeMaxMin',
                    uxdisabled: readonly,
                    hidden: dayTimeMaxMinHidden,
                    disabled: readonly? false : view.templateLimits.disableDayTimeMax,
                    type: 'slider',
                    value: view.employeeTypeTemplate.dayTimeMaxMin,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let max = datafill.entries.find(i => i.key == 'dayTimeMaxMax').value;
                        let slider = entryBeforeUpdate.slider;
                        slider.max = max;
                        slider.value = Math.min(slider.value, max)
                        let newSlider = Object.assign({}, slider)
                        entryBeforeUpdate.slider = newSlider;
                        entryBeforeUpdate.value = newSlider.value;
                        return entryBeforeUpdate;
                    },
                    slider: {
                        min: view.templateLimits.dayTimeMaxMinLimit,
                        max: view.employeeTypeTemplate.dayTimeMaxMax,
                        value: view.employeeTypeTemplate.dayTimeMaxMin,
                        step: 15,
                        DisplayLabel: (val) => {return val / 60},
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x * 60 },
                    }
                },
                {
                    label: view.$t('store.templates.maxHoursDayMax') + ': ',
                    key: 'dayTimeMaxMax',
                    uxdisabled: readonly,
                    hidden: dayTimeMaxMaxHidden,
                    disabled: readonly? false : view.templateLimits.disableDayTimeMax,
                    type: 'slider',
                    value: view.employeeTypeTemplate.dayTimeMaxMax,
                    slider: {
                        min: view.templateLimits.dayTimeMaxMinLimit,
                        max: view.templateLimits.dayTimeMaxMaxLimit,
                        value: view.employeeTypeTemplate.dayTimeMaxMax,
                        step: 15,
                        DisplayLabel: (val) => {return val / 60},
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x * 60 },
                    }
                },
                view.dividerOrFlat([dayTimeMaxMinHidden, dayTimeMaxMaxHidden]),
                {
                    label: view.$t('store.templates.restTimeShiftsMin') + ': ',
                    key: 'restTimeMin',
                    uxdisabled: readonly,
                    hidden: restTimeMinHidden,
                    disabled: readonly? false : view.templateLimits.disableRestTime,
                    type: 'slider',
                    value: view.employeeTypeTemplate.restTimeMin,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let max = datafill.entries.find(i => i.key == 'restTimeMax').value;
                        let slider = entryBeforeUpdate.slider;
                        slider.max = max;
                        slider.value = Math.min(slider.value, max)
                        let newSlider = Object.assign({}, slider)
                        entryBeforeUpdate.slider = newSlider;
                        entryBeforeUpdate.value = newSlider.value;
                        return entryBeforeUpdate;
                    },
                    slider: {
                        min: view.templateLimits.restTimeMinLimit,
                        max: view.employeeTypeTemplate.restTimeMax,
                        value: view.employeeTypeTemplate.restTimeMin,
                        step: 15,
                        DisplayLabel: (val) => {return val / 60},
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x * 60 },
                    }
                },
                {
                    label: view.$t('store.templates.restTimeShiftsMax') + ': ',
                    key: 'restTimeMax',
                    uxdisabled: readonly,
                    hidden: restTimeMaxHidden,
                    disabled: readonly? false : view.templateLimits.disableRestTime,
                    type: 'slider',
                    value: view.employeeTypeTemplate.restTimeMax,
                    slider: {
                        min: view.templateLimits.restTimeMinLimit,
                        max: view.templateLimits.restTimeMaxLimit,
                        value: view.employeeTypeTemplate.restTimeMax,
                        step: 15,
                        DisplayLabel: (val) => {return val / 60},
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x * 60 },
                    }
                },
                view.dividerOrFlat([restTimeMinHidden, restTimeMaxHidden]),
                {
                    label: view.$t('store.templates.freeDayMin') + ': ',
                    key: 'weekSpareDaysMinMin',
                    uxdisabled: readonly,
                    hidden: weekSpareDaysMinMinHidden,
                    disabled: readonly? false : view.templateLimits.disableWeekSpareDaysMin,
                    type: 'slider',
                    value: view.employeeTypeTemplate.weekSpareDaysMinMin,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let max = datafill.entries.find(i => i.key == 'weekSpareDaysMinMax').value;
                        let slider = entryBeforeUpdate.slider;
                        slider.max = max;
                        slider.value = Math.min(slider.value, max)
                        let newSlider = Object.assign({}, slider)
                        entryBeforeUpdate.slider = newSlider;
                        entryBeforeUpdate.value = newSlider.value;
                        return entryBeforeUpdate;
                    },
                    slider: {
                        min: view.templateLimits.weekSpareDaysMinMinLimit,
                        max: view.employeeTypeTemplate.weekSpareDaysMinMax,
                        value: view.employeeTypeTemplate.weekSpareDaysMinMin,
                        labelled: true,
                        step: 1,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {
                    label: view.$t('store.templates.freeDayMax') + ': ',
                    key: 'weekSpareDaysMinMax',
                    uxdisabled: readonly,
                    hidden: weekSpareDaysMinMaxHidden,
                    disabled: readonly? false : view.templateLimits.disableWeekSpareDaysMin,
                    type: 'slider',
                    value: view.employeeTypeTemplate.weekSpareDaysMinMax,
                    slider: {
                        min: view.templateLimits.weekSpareDaysMinMinLimit,
                        max: view.templateLimits.weekSpareDaysMinMaxLimit,
                        value: view.employeeTypeTemplate.weekSpareDaysMinMax,
                        labelled: true,
                        step: 1,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                view.dividerOrFlat([weekSpareDaysMinMinHidden, weekSpareDaysMinMaxHidden]),
                {
                    label: view.$t('store.templates.additionalFreeTime') + ': ',
                    key: 'weekAdditionalSpareTime',
                    uxdisabled: readonly,
                    hidden: weekAdditionalSpareTimeHidden,
                    disabled: readonly? false : view.templateLimits.disableWeekAdditionalSpareTime,
                    type: 'slider',
                    value: view.employeeTypeTemplate.weekAdditionalSpareTime,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let minDays = datafill.entries.find(i => i.key == 'weekSpareDaysMinMin').value;
                        let slider = entryBeforeUpdate.slider;
                        if(contract){
                            let contractMinSpareTime = contract.weekSpareTimeMin - minDays * 24 *60;
                            let min = Math.max(0, contractMinSpareTime);
                            slider.min = min;
                            slider.value = Math.max(slider.value, Math.max(min, 0));
                        }
                        let newSlider = Object.assign({}, slider)
                        entryBeforeUpdate.slider = newSlider;
                        entryBeforeUpdate.value = newSlider.value;
                        return entryBeforeUpdate;
                    },
                    slider: {
                        min: contract ? (Math.max(contract.weekSpareTimeMin - view.employeeTypeTemplate.weekSpareDaysMinMin *24*60, 0)) : view.templateLimits.weekAdditionalSpareTimeMinLimit,
                        max: view.templateLimits.weekAdditionalSpareTimeMaxLimit,
                        value: view.employeeTypeTemplate.weekAdditionalSpareTime,
                        step: 15,
                        DisplayLabel: (val) => {return val / 60},
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x * 60 },
                    }
                },
                {key: 'weekSpareTimeStartType', uxdisabled: readonly, hidden: false, type: 'dropdownsearch', value: view.employeeTypeTemplate.weekSpareTimeStartType ? view.employeeTypeTemplate.weekSpareTimeStartType : 1, selectMultiple: false, flexGroup: true, dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: weekSpareTimeStartTypes,
                        selectMultiple: false,
                        selectedItems: [],
                        selectedItem: selectedWeekSpareTimeStartType,
                        onceSelected: function ($event, item, searchbar){
                        },
                        styleLight: true,
                        placeholder: view.$t('store.settings.templateWeeklyPlanning'),
                    }, styles: {width: '600px'}},
                {
                    label: view.$t('store.settings.freeTimeTargetMin') + ': ',
                    key: 'weekSpareTimeStartMin',
                    uxdisabled: readonly,
                    hidden: view.employeeTypeTemplate.weekSpareTimeStartType ? (view.employeeTypeTemplate.weekSpareTimeStartType == 1) : true,

                    type: 'timeframe',
                    value: view.employeeTypeTemplate.weekSpareTimeStartMin ? view.employeeTypeTemplate.weekSpareTimeStartMin : '08:00',
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let weekSpareTimeStartType = datafill.entries.find(i => i.key == 'weekSpareTimeStartType').value;

                        if(weekSpareTimeStartType != 1){
                            entryBeforeUpdate.hidden = false;

                        } else {
                            entryBeforeUpdate.hidden = true;
                        }

                        return entryBeforeUpdate;
                    },
                },
                {
                    label: view.$t('store.settings.freeTimeTargetMax') + ': ',
                    key: 'weekSpareTimeStartMax',
                    uxdisabled: readonly,
                    hidden: view.employeeTypeTemplate.weekSpareTimeStartType ? (view.employeeTypeTemplate.weekSpareTimeStartType == 1) : true,
                    type: 'timeframe',
                    value: view.employeeTypeTemplate.weekSpareTimeStartMax ? view.employeeTypeTemplate.weekSpareTimeStartMax : '12:00',
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let weekSpareTimeStartType = datafill.entries.find(i => i.key == 'weekSpareTimeStartType').value;

                        if(weekSpareTimeStartType != 1){
                            entryBeforeUpdate.hidden = false;

                        } else {
                            entryBeforeUpdate.hidden = true;
                        }

                        return entryBeforeUpdate;
                    },
                },
                {divider: true},
                {
                    label: view.$t('store.templates.multiShiftDaying') + ': ',
                    key: 'allowMultipleShifts',
                    uxdisabled: readonly,
                    hidden: false,
                    type: 'bool',
                    value: view.employeeTypeTemplate.allowMultipleShifts,
                },
                {
                    label: view.$t('store.templates.minPauseBetweenShiftsMin') + ': ',
                    key: 'shiftBetweenTimeMinMin',
                    uxdisabled: readonly,
                    hidden: false,
                    type: 'slider',
                    value: view.employeeTypeTemplate.shiftBetweenTimeMinMin,
                    hiddenBoundToInverse: 'allowMultipleShifts',
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let max = datafill.entries.find(i => i.key == 'shiftBetweenTimeMinMax').value;
                        let slider = entryBeforeUpdate.slider;
                        slider.max = max;
                        slider.value = Math.max(0,Math.min(slider.value, max));
                        let newSlider = Object.assign({}, slider)
                        entryBeforeUpdate.slider = newSlider;
                        entryBeforeUpdate.value = newSlider.value;
                        return entryBeforeUpdate;
                    },
                    slider: {
                        min: 0,
                        max: view.employeeTypeTemplate.shiftBetweenTimeMinMax,
                        value: Math.max(0,view.employeeTypeTemplate.shiftBetweenTimeMinMin),
                        step: 15,
                        DisplayLabel: (val) => {return val / 60},
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x * 60 },
                    }
                },
                {
                    label: view.$t('store.templates.minPauseBetweenShiftsMax') + ': ',
                    key: 'shiftBetweenTimeMinMax',
                    uxdisabled: readonly,
                    hidden: false,
                    hiddenBoundToInverse: 'allowMultipleShifts',
                    type: 'slider',
                    value: view.employeeTypeTemplate.shiftBetweenTimeMinMax,
                    slider: {
                        min: 0,
                        max: 24*60,
                        value: Math.max(0,view.employeeTypeTemplate.shiftBetweenTimeMinMax),
                        step: 15,
                        DisplayLabel: (val) => {return val / 60},
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x * 60 },
                    }
                },
                {
                    label: view.$t('store.templates.maxPauseBetweenShiftsMin') + ': ',
                    key: 'shiftBetweenTimeMaxMin',
                    uxdisabled: readonly,
                    hidden: false,
                    type: 'slider',
                    value: view.employeeTypeTemplate.shiftBetweenTimeMaxMin,
                    hiddenBoundToInverse: 'allowMultipleShifts',
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let max = datafill.entries.find(i => i.key == 'shiftBetweenTimeMaxMax').value;
                        let slider = entryBeforeUpdate.slider;
                        slider.max = max;
                        slider.value = Math.max(0,Math.min(slider.value, max));
                        let newSlider = Object.assign({}, slider)
                        entryBeforeUpdate.slider = newSlider;
                        entryBeforeUpdate.value = newSlider.value;
                        return entryBeforeUpdate;
                    },
                    slider: {
                        min: 0,
                        max: view.employeeTypeTemplate.shiftBetweenTimeMaxMax,
                        value: Math.max(0,view.employeeTypeTemplate.shiftBetweenTimeMaxMin),
                        step: 15,
                        DisplayLabel: (val) => {return val / 60},
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x * 60 },
                    }
                },
                {
                    label: view.$t('store.templates.maxPauseBetweenShiftsMax') + ': ',
                    key: 'shiftBetweenTimeMaxMax',
                    uxdisabled: readonly,
                    hidden: false,
                    hiddenBoundToInverse: 'allowMultipleShifts',
                    type: 'slider',
                    value: view.employeeTypeTemplate.shiftBetweenTimeMaxMax,
                    slider: {
                        min: 0,
                        max: 24*60,
                        value: Math.max(0,view.employeeTypeTemplate.shiftBetweenTimeMaxMax),
                        step: 15,
                        DisplayLabel: (val) => {return val / 60},
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x * 60 },
                    }
                },
                {divider: true},
                {
                    label: view.$t('store.templates.limitConsecutiveDays') + ': ',
                    key: 'limitConsecutiveDays',
                    uxdisabled: readonly,
                    hidden: false,
                    type: 'bool',
                    value: view.employeeTypeTemplate.limitConsecutiveDays,
                },
                {
                    label: view.$t('store.templates.daysConsecutiveMaxMin') + ': ',
                    key: 'daysConsecutiveMaxMin',
                    uxdisabled: readonly,
                    hidden: false,
                    type: 'slider',
                    value: view.employeeTypeTemplate.daysConsecutiveMaxMin,
                    hiddenBoundToInverse: 'limitConsecutiveDays',
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let max = datafill.entries.find(i => i.key == 'daysConsecutiveMaxMax').value;
                        let slider = entryBeforeUpdate.slider;
                        slider.max = max;
                        slider.value = Math.max(0,Math.min(slider.value, max));
                        let newSlider = Object.assign({}, slider)
                        entryBeforeUpdate.slider = newSlider;
                        entryBeforeUpdate.value = newSlider.value;
                        return entryBeforeUpdate;
                    },
                    slider: {
                        min: 0,
                        value: Math.max(0,view.employeeTypeTemplate.daysConsecutiveMaxMin),
                        max: view.employeeTypeTemplate.daysConsecutiveMaxMax,
                        labelled: true,
                        step: 1,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {
                    label: view.$t('store.templates.daysConsecutiveMaxMax') + ': ',
                    key: 'daysConsecutiveMaxMax',
                    uxdisabled: readonly,
                    hidden: false,
                    type: 'slider',
                    value: view.employeeTypeTemplate.daysConsecutiveMaxMax,
                    hiddenBoundToInverse: 'limitConsecutiveDays',
                    slider: {
                        min: 0,
                        value: Math.max(0,view.employeeTypeTemplate.daysConsecutiveMaxMax),
                        max: 31,
                        labelled: true,
                        step: 1,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {divider: true},
                {
                    label: view.$t('store.templates.limitOvertime') + ': ',
                    key: 'limitOvertime',
                    uxdisabled: readonly,
                    hidden: false,
                    type: 'bool',
                    value: view.employeeTypeTemplate.limitOvertime,
                },
                {
                    label: view.$t('store.templates.monthOvertimeMaxMin') + ': ',
                    key: 'monthOvertimeMaxMin',
                    uxdisabled: readonly,
                    hidden: false,
                    type: 'slider',
                    value: view.employeeTypeTemplate.monthOvertimeMaxMin,
                    hiddenBoundToInverse: 'limitOvertime',
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let max = datafill.entries.find(i => i.key == 'monthOvertimeMaxMax').value;
                        let slider = entryBeforeUpdate.slider;
                        slider.max = max;
                        slider.value = Math.max(0,Math.min(slider.value, max))
                        let newSlider = Object.assign({}, slider)
                        entryBeforeUpdate.slider = newSlider;
                        entryBeforeUpdate.value = newSlider.value;
                        return entryBeforeUpdate;
                    },
                    slider: {
                        min: 0,
                        max: view.employeeTypeTemplate.monthOvertimeMaxMax,
                        value: Math.max(0,view.employeeTypeTemplate.monthOvertimeMaxMin),
                        step: 15,
                        DisplayLabel: (val) => {return val / 60},
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x * 60 },
                    }
                },
                {
                    label: view.$t('store.templates.monthOvertimeMaxMax') + ': ',
                    key: 'monthOvertimeMaxMax',
                    uxdisabled: readonly,
                    hidden: false,
                    type: 'slider',
                    value: view.employeeTypeTemplate.monthOvertimeMaxMax,
                    hiddenBoundToInverse: 'limitOvertime',
                    slider: {
                        min: 0,
                        max: 100*60,
                        value: Math.max(0,view.employeeTypeTemplate.monthOvertimeMaxMax),
                        step: 15,
                        DisplayLabel: (val) => {return val / 60},
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x * 60 },
                    }
                },
                {divider: true},
                {
                    label: view.$t('store.templates.limitWorkDaysWeek') + ': ',
                    key: 'useWorkDaysForSpareTime',
                    uxdisabled: readonly,
                    hidden: false,
                    type: 'bool',
                    value: view.employeeTypeTemplate.useWorkDaysForSpareTime,
                },
                {
                    label: view.$t('store.templates.weekWorkDaysMaxMin') + ': ',
                    key: 'weekWorkDaysMaxMin',
                    uxdisabled: readonly,
                    hidden: false,
                    type: 'slider',
                    value: view.employeeTypeTemplate.weekWorkDaysMaxMin,
                    hiddenBoundToInverse: 'useWorkDaysForSpareTime',
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let max = datafill.entries.find(i => i.key == 'weekWorkDaysMaxMax').value;
                        let slider = entryBeforeUpdate.slider;
                        slider.max = max;
                        slider.value = Math.max(0,Math.min(slider.value, max))
                        let newSlider = Object.assign({}, slider)
                        entryBeforeUpdate.slider = newSlider;
                        entryBeforeUpdate.value = newSlider.value;
                        return entryBeforeUpdate;
                    },
                    slider: {
                        min: 0,
                        value: view.employeeTypeTemplate.weekWorkDaysMaxMin,
                        max: view.employeeTypeTemplate.weekWorkDaysMaxMax,
                        labelled: true,
                        step: 1,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {
                    label: view.$t('store.templates.weekWorkDaysMaxMax') + ': ',
                    key: 'weekWorkDaysMaxMax',
                    uxdisabled: readonly,
                    hidden: false,
                    type: 'slider',
                    value: view.employeeTypeTemplate.weekWorkDaysMaxMax,
                    hiddenBoundToInverse: 'useWorkDaysForSpareTime',
                    slider: {
                        min: 0,
                        max: 7,
                        value: Math.max(0,view.employeeTypeTemplate.weekWorkDaysMaxMax),
                        labelled: true,
                        step: 1,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {divider: true},
                {
                    label: view.$t('store.templates.limitEmployeeCount') + ': ',
                    key: 'limitEmployeeCount',
                    uxdisabled: readonly,
                    hidden: false,
                    type: 'bool',
                    value: view.employeeTypeTemplate.limitEmployeeCount,
                },
                {
                    label: view.$t('store.templates.maxEmployeeCount') + ': ',
                    key: 'employeeCountMax',
                    uxdisabled: readonly,
                    hidden: false,
                    type: 'slider',
                    value: view.employeeTypeTemplate.employeeCountMax,
                    hiddenBoundToInverse: 'limitEmployeeCount',
                    slider: {
                        min: 1,
                        max: 200,
                        value: view.employeeTypeTemplate.employeeCountMax,
                        labelled: true,
                        step: 1,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {
                    flexDivider: true,
                    styles: {
                        'margin-bottom': '23px'
                    }
                },
            ];

            let contractEntry = {
                label: (this.storeSettings.country == 1 ? this.$t('pages.employeeContract.collectiveContract') : this.$t('pages.employeeContract.contractModel')) +': ',
                key: 'contractId',
                uxdisabled: edit,
                hidden: contract == null && edit,
                type: 'dropdownsearch',
                value: null,
                selectMultiple: false,
                flexGroup: true,
                dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: allowedContracts,
                    selectMultiple: false,
                    selectedItems: [selectedAllowedContract],
                    selectedItem: selectedAllowedContract,
                    onceSelected: function ($event, item, searchbar){
                        console.log(JSON.stringify(item));
                        view.setContractLimits(item.value);
                        view.setEmployeeTypeTemplateValues(item.value);
                        view.updateEmployeeTypeTemplatePopupState(dataEntries);
                    },
                    styleLight: true,
                    placeholder: '',
                },
                styles: {
                    'width': '600px'
                }
            }
            dataEntries.splice(1, 0, contractEntry);

            this.$helpers.OpenPopup({
                elRelative: null,
                type: 'datafill',
                pointerDirection: -1,
                componentState: {
                    entries: dataEntries,
                    selectCallback: function (inputData) {
                        if(!readonly){
                            console.log(inputData);
                            if(edit){
                                // edit
                                view.editEmployeeTypeTemplate(inputData);
                            }else{
                                // create
                                view.createEmployeeTypeTemplate(inputData);
                            }
                        }
                    },
                    deleteCallback: readonly? null : function () {},
                    negativeButtonLabel: view.$t('global.ui.cancel'),
                    positiveButtonLabel: readonly? view.$t('global.ui.ok') : edit? view.$t('global.ui.save') : view.$t('global.ui.create')
                },
                header: readonly? view.$t('store.templates.details') : edit? view.$t('store.templates.edit') : view.$t('store.templates.planingCreateTitle'),
                remainAfterSelect: false,
                width: '900px',
                centered: true,
                expanded: true,
            });
        },
        updateEmployeeTypeTemplatePopupState(dataEntries){
            let view = this;
            let entry = dataEntries.find(i => i.key == 'weekTimeRegularMax');
            let slider = entry.slider;
            let newSlider = Object.assign({}, slider)
            newSlider.min = view.templateLimits.weekTimeRegularMinLimit,
                newSlider.max = view.templateLimits.weekTimeRegularMaxLimit,
                newSlider.value = view.employeeTypeTemplate.weekTimeRegularMax,
                entry.slider = newSlider;
            entry.value = newSlider.value;

            entry = dataEntries.find(i => i.key == 'weekTimeRegularMin');
            slider = entry.slider;
            newSlider = Object.assign({}, slider)
            newSlider.min = view.templateLimits.weekTimeRegularMinLimit,
                newSlider.max = view.employeeTypeTemplate.weekTimeRegularMax,
                newSlider.value = view.employeeTypeTemplate.weekTimeRegularMin,
                entry.slider = newSlider;
            entry.value = newSlider.value;

            entry = dataEntries.find(i => i.key == 'monthTimeMaxAdjustmentMin');
            slider = entry.slider;
            newSlider = Object.assign({}, slider)
            newSlider.min = view.templateLimits.monthTimeMaxAdjustmentMinLimit,
                newSlider.max = view.employeeTypeTemplate.monthTimeMaxAdjustmentMax,
                newSlider.value = view.employeeTypeTemplate.monthTimeMaxAdjustmentMin,
                entry.slider = newSlider;
            entry.value = newSlider.value;

            entry = dataEntries.find(i => i.key == 'monthTimeMaxAdjustmentMax');
            slider = entry.slider;
            newSlider = Object.assign({}, slider)
            newSlider.min = view.templateLimits.monthTimeMaxAdjustmentMinLimit,
                newSlider.max = view.templateLimits.monthTimeMaxAdjustmentMaxLimit,
                newSlider.value = view.employeeTypeTemplate.monthTimeMaxAdjustmentMax,
                entry.slider = newSlider;
            entry.value = newSlider.value;

            entry = dataEntries.find(i => i.key == 'weekTimeMaxMin');
            slider = entry.slider;
            newSlider = Object.assign({}, slider)
            newSlider.min = view.templateLimits.weekTimeMaxMinLimit,
                newSlider.max = view.employeeTypeTemplate.weekTimeMaxMax,
                newSlider.value = view.employeeTypeTemplate.weekTimeMaxMin,
                entry.slider = newSlider;
            entry.value = newSlider.value;

            entry = dataEntries.find(i => i.key == 'weekTimeMaxMax');
            slider = entry.slider;
            newSlider = Object.assign({}, slider)
            newSlider.min = view.templateLimits.weekTimeMaxMinLimit,
                newSlider.max = view.templateLimits.weekTimeMaxMaxLimit,
                newSlider.value = view.employeeTypeTemplate.weekTimeMaxMax,
                entry.slider = newSlider;
            entry.value = newSlider.value;

            entry = dataEntries.find(i => i.key == 'weekWorkDaysRegularMin');
            slider = entry.slider;
            newSlider = Object.assign({}, slider)
            newSlider.min = view.templateLimits.weekWorkDaysRegularMinLimit,
                newSlider.max = view.employeeTypeTemplate.weekWorkDaysRegularMax,
                newSlider.value = view.employeeTypeTemplate.weekWorkDaysRegularMin,
                entry.slider = newSlider;
            entry.value = newSlider.value;

            entry = dataEntries.find(i => i.key == 'weekWorkDaysRegularMax');
            slider = entry.slider;
            newSlider = Object.assign({}, slider)
            newSlider.min = view.templateLimits.weekWorkDaysRegularMinLimit,
                newSlider.max = view.templateLimits.weekWorkDaysRegularMaxLimit,
                newSlider.value = view.employeeTypeTemplate.weekWorkDaysRegularMax,
                entry.slider = newSlider;
            entry.value = newSlider.value;

            entry = dataEntries.find(i => i.key == 'dayTimeRegularMin');
            slider = entry.slider;
            newSlider = Object.assign({}, slider)
            newSlider.min = view.templateLimits.dayTimeRegularMinLimit,
                newSlider.max = view.employeeTypeTemplate.dayTimeRegularMax,
                newSlider.value = view.employeeTypeTemplate.dayTimeRegularMin,
                entry.slider = newSlider;
            entry.value = newSlider.value;

            entry = dataEntries.find(i => i.key == 'dayTimeRegularMax');
            slider = entry.slider;
            newSlider = Object.assign({}, slider)
            newSlider.min = view.templateLimits.dayTimeRegularMinLimit,
                newSlider.max = view.templateLimits.dayTimeRegularMaxLimit,
                newSlider.value = view.employeeTypeTemplate.dayTimeRegularMax,
                entry.slider = newSlider;
            entry.value = newSlider.value;

            entry = dataEntries.find(i => i.key == 'dayTimeMaxMin');
            slider = entry.slider;
            newSlider = Object.assign({}, slider)
            newSlider.min = view.templateLimits.dayTimeMaxMinLimit,
                newSlider.max = view.employeeTypeTemplate.dayTimeMaxMax,
                newSlider.value = view.employeeTypeTemplate.dayTimeMaxMin,
                entry.slider = newSlider;
            entry.value = newSlider.value;

            entry = dataEntries.find(i => i.key == 'dayTimeMaxMax');
            slider = entry.slider;
            newSlider = Object.assign({}, slider)
            newSlider.min = view.templateLimits.dayTimeMaxMinLimit,
                newSlider.max = view.templateLimits.dayTimeMaxMaxLimit,
                newSlider.value = view.employeeTypeTemplate.dayTimeMaxMax,
                entry.slider = newSlider;
            entry.value = newSlider.value;

            entry = dataEntries.find(i => i.key == 'restTimeMin');
            slider = entry.slider;
            newSlider = Object.assign({}, slider)
            newSlider.min = view.templateLimits.restTimeMinLimit,
                newSlider.max = view.employeeTypeTemplate.restTimeMax,
                newSlider.value = view.employeeTypeTemplate.restTimeMin,
                entry.slider = newSlider;
            entry.value = newSlider.value;

            entry = dataEntries.find(i => i.key == 'restTimeMax');
            slider = entry.slider;
            newSlider = Object.assign({}, slider)
            newSlider.min = view.templateLimits.restTimeMinLimit,
                newSlider.max = view.templateLimits.restTimeMaxLimit,
                newSlider.value = view.employeeTypeTemplate.restTimeMax,
                entry.slider = newSlider;
            entry.value = newSlider.value;

            entry = dataEntries.find(i => i.key == 'weekSpareDaysMinMin');
            slider = entry.slider;
            newSlider = Object.assign({}, slider)
            newSlider.min = view.templateLimits.weekSpareDaysMinMinLimit,
                newSlider.max = view.employeeTypeTemplate.weekSpareDaysMinMax,
                newSlider.value = view.employeeTypeTemplate.weekSpareDaysMinMin,
                entry.slider = newSlider;
            entry.value = newSlider.value;

            entry = dataEntries.find(i => i.key == 'weekSpareDaysMinMax');
            slider = entry.slider;
            newSlider = Object.assign({}, slider)
            newSlider.min = view.templateLimits.weekSpareDaysMinMinLimit,
                newSlider.max = view.templateLimits.weekSpareDaysMinMaxLimit,
                newSlider.value = view.employeeTypeTemplate.weekSpareDaysMinMax,
                entry.slider = newSlider;
            entry.value = newSlider.value;

            entry = dataEntries.find(i => i.key == 'weekAdditionalSpareTime');
            slider = entry.slider;
            newSlider = Object.assign({}, slider)
            newSlider.min = view.templateLimits.weekAdditionalSpareTimeMinLimit,
                newSlider.max = view.templateLimits.weekAdditionalSpareTimeMaxLimit,
                newSlider.value = view.employeeTypeTemplate.weekAdditionalSpareTime,
                entry.slider = newSlider;
            entry.value = newSlider.value;

            entry = dataEntries.find(i => i.key == 'weekTimeAvgType');
            let dropdownState = Object.assign({}, entry.dropdownSearchState);
            let items = dropdownState.items.filter(t => t.value >= this.employeeTypeTemplate.weekTimeAvgType);
            let selectedItem = dropdownState.items.find(t => t.value >= this.employeeTypeTemplate.weekTimeAvgType);
            dropdownState.items = items;
            dropdownState.selectedItem = selectedItem;
            dropdownState.selectedItems = [selectedItem];
            entry.dropdownSearchState = dropdownState;

            entry = dataEntries.find(i => i.key == 'monthTimeMaxType');
            dropdownState = Object.assign({}, entry.dropdownSearchState);
            items = dropdownState.items.filter(t => t.value >= this.employeeTypeTemplate.monthTimeMaxType);
            selectedItem = dropdownState.items.find(t => t.value >= this.employeeTypeTemplate.monthTimeMaxType);
            dropdownState.items = items;
            dropdownState.selectedItem = selectedItem;
            dropdownState.selectedItems = [selectedItem];
            entry.dropdownSearchState = dropdownState;



        },
        setEmployeeTypeTemplateValues: function (val) {
            if (val != null && this.allowedContractMap[val] != null) {
                let allowedContract = this.allowedContractMap[val];
                let collectiveContract = this.collectiveContractMap[allowedContract.collectiveContractId];

                this.employeeTypeTemplate = {
                    contractId: val,
                    name: this.employeeTypeTemplate.name,

                    monthTimeMaxType: collectiveContract.monthTimeMaxType,

                    monthTimeMaxAdjustmentMin: collectiveContract.monthTimeMaxAdjustment > -31*12*60 ? -31*12*60 : -31*24*60,
                    monthTimeMaxAdjustmentMax: collectiveContract.monthTimeMaxAdjustment > 31*12*60 ? 31*12*60 : collectiveContract.monthTimeMaxAdjustment,

                    weekTimeMaxMin: 60,
                    weekTimeMaxMax: Math.floor(collectiveContract.weekTimeMax),

                    weekTimeRegularMin: 60,
                    weekTimeRegularMax: Math.floor(allowedContract.weekTimeRegular),

                    dayTimeMaxMin: 60,
                    dayTimeMaxMax: Math.floor(collectiveContract.dayTimeMax),

                    dayTimeRegularMin: 60,
                    dayTimeRegularMax: Math.floor(collectiveContract.dayTimeRegular),

                    restTimeMin: Math.floor(collectiveContract.restTime),
                    restTimeMax: 24*60,

                    weekSpareDaysMinMin: collectiveContract.weekSpareDaysMin,
                    weekSpareDaysMinMax: 7,
                    weekAdditionalSpareTime: Math.floor(collectiveContract.weekSpareTimeMin) - (collectiveContract.weekSpareDaysMin * 24 *60),
                    weekTimeAvgType: collectiveContract.weekTimeAvgType,

                    allowMultipleShifts: false,
                    shiftBetweenTimeMinMin: 0,
                    shiftBetweenTimeMinMax: 0,
                    shiftBetweenTimeMaxMin: 3*60,
                    shiftBetweenTimeMaxMax: 3*60,
                    limitConsecutiveDays: false,
                    daysConsecutiveMaxMin: 6,
                    daysConsecutiveMaxMax: 6,
                    limitOvertime: false,
                    monthOvertimeMaxMin: 0,
                    monthOvertimeMaxMax: 20*60,
                    overtimeCutoffMin: 60,
                    overtimeCutoffMax: 480,
                    useWorkDaysForSpareTime: false,
                    weekWorkDaysMaxMin: 1,
                    weekWorkDaysMaxMax: 7,
                    weekWorkDaysRegularMin: 1,
                    weekWorkDaysRegularMax: allowedContract.weekWorkDaysRegular,
                    weekSpareTimeStartType: 1,
                    weekSpareTimeStartMin: null,
                    weekSpareTimeStartMax: null,
                    limitEmployeeCount: false,
                    employeeCountMax: null
                };

            } else {
                this.resetEmployeeTypeTemplateValues();
            }
        },
        setContractLimits: function (val) {
            if (val != null && this.allowedContractMap[val] != null) {
                let allowedContract = this.allowedContractMap[val];
                let collectiveContract = this.collectiveContractMap[allowedContract.collectiveContractId];

                this.templateLimits = {
                    disableMonthTimeMaxType: false,

                    disableMonthTimeRegular: false,
                    monthTimeMaxAdjustmentMinLimit: collectiveContract.monthTimeMaxAdjustment > -31*12*60 ? -31*12*60 : -31*24*60,
                    monthTimeMaxAdjustmentMaxLimit: collectiveContract.monthTimeMaxAdjustment > 31*12*60 ? 31*12*60 : Math.floor(collectiveContract.monthTimeMaxAdjustment),
                    disableMonthTimeMaxAdjustment: false,
                    weekTimeRegularMinLimit: 0*60,
                    weekTimeRegularMaxLimit: Math.floor(allowedContract.weekTimeRegular),
                    disableWeekTimeRegular: false,
                    weekTimeMaxMinLimit: 0*60,
                    weekTimeMaxMaxLimit: Math.floor(collectiveContract.weekTimeMax),
                    disableWeekTimeMax: false,
                    disableWeekTimeAvgType: false,
                    dayTimeRegularMinLimit: 0*60,
                    dayTimeRegularMaxLimit: Math.floor(collectiveContract.dayTimeRegular),
                    disableDayTimeRegular: false,
                    dayTimeMaxMinLimit: 0*60,
                    dayTimeMaxMaxLimit: Math.floor(collectiveContract.dayTimeMax),
                    disableDayTimeMax: false,
                    weekWorkDaysRegularMinLimit: 0,
                    weekWorkDaysRegularMaxLimit: allowedContract.weekWorkDaysRegular,
                    disableWeekWorkDaysRegular: false,
                    restTimeMinLimit: Math.floor(collectiveContract.restTime),
                    restTimeMaxLimit: 24*60,
                    disableRestTime: false,
                    weekSpareDaysMinMinLimit: collectiveContract.weekSpareDaysMin,
                    weekSpareDaysMinMaxLimit: 7,
                    disableWeekSpareDaysMin: false,
                    weekAdditionalSpareTimeMinLimit: Math.floor(collectiveContract.weekSpareTimeMin) - (collectiveContract.weekSpareDaysMin * 24 *60),
                    weekAdditionalSpareTimeMaxLimit: 48*60,
                    disableWeekAdditionalSpareTime: false,

                };
            } else {
                this.resetEmployeeTypeTemplateLimits();
            }

        },
        createEmployeeTypeTemplate(input) {
            let view = this;
            view.loadingStart();
            let url = '/api/sec/employeetypetemplate';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeetypetemplate');

            let payload = {
                storeId: this.$store.state.storeId,
            }

            payload.name = input.name;
            payload.contractId = input.contractId;
            payload.monthTimeRegularMin = Math.round(input.weekTimeRegularMin *4.325);
            payload.monthTimeRegularMax = Math.round(input.weekTimeRegularMax *4.325);

            payload.monthTimeMaxType = input.monthTimeMaxType;

            payload.monthTimeMaxAdjustmentMin = input.monthTimeMaxAdjustmentMin;
            payload.monthTimeMaxAdjustmentMax = input.monthTimeMaxAdjustmentMax;

            payload.weekTimeMaxMin = input.weekTimeMaxMin;
            payload.weekTimeMaxMax = input.weekTimeMaxMax;

            payload.weekTimeRegularMin = input.weekTimeRegularMin;
            payload.weekTimeRegularMax = input.weekTimeRegularMax;

            payload.dayTimeRegularMin = input.dayTimeRegularMin;
            payload.dayTimeRegularMax = input.dayTimeRegularMax;

            payload.dayTimeMaxMin = input.dayTimeMaxMin;
            payload.dayTimeMaxMax = input.dayTimeMaxMax;

            payload.restTimeMin = input.restTimeMin;
            payload.restTimeMax = input.restTimeMax;

            payload.weekWorkDaysRegularMin = input.weekWorkDaysRegularMin;
            payload.weekWorkDaysRegularMax = input.weekWorkDaysRegularMax;

            payload.overtimeCutoffMin = input.dayTimeRegularMin;
            payload.overtimeCutoffMax = Math.max(input.dayTimeRegularMax, input.dayTimeMaxMax);

            if (input.allowMultipleShifts) {
                payload.shiftBetweenTimeMinMin = input.shiftBetweenTimeMinMin;
                payload.shiftBetweenTimeMinMax = input.shiftBetweenTimeMinMax;

                payload.shiftBetweenTimeMaxMin = input.shiftBetweenTimeMaxMin;
                payload.shiftBetweenTimeMaxMax = input.shiftBetweenTimeMaxMax;
            } else {
                payload.shiftBetweenTimeMinMin = -1;
                payload.shiftBetweenTimeMinMax = -1;

                payload.shiftBetweenTimeMaxMin = -1;
                payload.shiftBetweenTimeMaxMax = -1;
            }

            if (input.limitConsecutiveDays) {
                payload.daysConsecutiveMaxMin = input.daysConsecutiveMaxMin;
                payload.daysConsecutiveMaxMax = input.daysConsecutiveMaxMax;
            } else {
                payload.daysConsecutiveMaxMin = -1;
                payload.daysConsecutiveMaxMax = -1;
            }

            if (input.limitOvertime) {
                payload.monthOvertimeMaxMin = input.monthOvertimeMaxMin;
                payload.monthOvertimeMaxMax = input.monthOvertimeMaxMax;
            } else {
                payload.monthOvertimeMaxMin = -1;
                payload.monthOvertimeMaxMax = -1;
            }

            if (input.useWorkDaysForSpareTime) {
                payload.weekWorkDaysMaxMin = input.weekWorkDaysMaxMin;
                payload.weekWorkDaysMaxMax = input.weekWorkDaysMaxMax;
            } else {
                payload.weekWorkDaysMaxMin = -1;
                payload.weekWorkDaysMaxMax = -1;
            }

            payload.weekSpareDaysMinMin = input.weekSpareDaysMinMin;
            payload.weekSpareDaysMinMax = input.weekSpareDaysMinMax;

            payload.weekSpareTimeMinMin = input.weekSpareDaysMinMin * 24 * 60 + input.weekAdditionalSpareTime;
            payload.weekSpareTimeMinMax = input.weekSpareDaysMinMax * 24 * 60 + input.weekAdditionalSpareTime;
            payload.weekTimeAvgType = input.weekTimeAvgType;

            payload.weekSpareTimeStartType = input.weekSpareTimeStartType;
            if (payload.weekSpareTimeStartType == 1) {
                payload.weekSpareTimeStartMin = null;
                payload.weekSpareTimeStartMax = null;
            } else {
                payload.weekSpareTimeStartMin = input.weekSpareTimeStartMin.format("HH:mmZ");
                payload.weekSpareTimeStartMax = input.weekSpareTimeStartMax.format("HH:mmZ");
            }

            if (input.limitEmployeeCount) {
                payload.employeeCountMax = input.employeeCountMax;
            } else {
                payload.employeeCountMax = null;
            }

            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {

                view.$store.commit("setEmployeeTypeTemplateMapEntry", response.data.data);

                view.loadingStop();
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('store.templates.planingCreate'));
            }).catch(function (error) {
                view.loadingStop();
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.templates.planingCreateError'));
                console.log(error)
            })
        },

        editEmployeeTypeTemplate(input) {
            let view = this;
            view.loadingStart();
            let url = '/api/sec/employeetypetemplate';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeetypetemplate');

            let payload = {
                id: this.templateId,
                updateFields: ["name", "monthTimeRegularMin", "monthTimeRegularMax", "monthTimeMaxType", "monthTimeMaxAdjustmentMin", "monthTimeMaxAdjustmentMax",
                    "weekTimeMaxMin", "weekTimeMaxMax", "weekTimeRegularMin", "weekTimeRegularMax", "dayTimeRegularMin", "dayTimeRegularMax",
                    "dayTimeMaxMin", "dayTimeMaxMax", "restTimeMin", "restTimeMax", "weekWorkDaysRegularMin", "weekWorkDaysRegularMax",
                    "overtimeCutoffMin", "overtimeCutoffMax", "shiftBetweenTimeMinMin", "shiftBetweenTimeMinMax", "shiftBetweenTimeMaxMin", "shiftBetweenTimeMaxMax",
                    "daysConsecutiveMaxMin", "daysConsecutiveMaxMax", "monthOvertimeMaxMin", "monthOvertimeMaxMax", "weekWorkDaysMaxMin", "weekWorkDaysMaxMax",
                    "weekSpareDaysMinMin", "weekSpareDaysMinMax", "weekSpareTimeMinMin", "weekSpareTimeMinMax", "weekTimeAvgType",
                    "weekSpareTimeStartType", "weekSpareTimeStartMin", "weekSpareTimeStarMax", "employeeCountMax"
                ]
            }

            payload.name = input.name;

            payload.monthTimeRegularMin = Math.round(input.weekTimeRegularMin *4.325);
            payload.monthTimeRegularMax = Math.round(input.weekTimeRegularMax *4.325);

            payload.monthTimeMaxType = input.monthTimeMaxType;

            payload.monthTimeMaxAdjustmentMin = input.monthTimeMaxAdjustmentMin;
            payload.monthTimeMaxAdjustmentMax = input.monthTimeMaxAdjustmentMax;

            payload.weekTimeMaxMin = input.weekTimeMaxMin;
            payload.weekTimeMaxMax = input.weekTimeMaxMax;

            payload.weekTimeRegularMin = input.weekTimeRegularMin;
            payload.weekTimeRegularMax = input.weekTimeRegularMax;

            payload.dayTimeRegularMin = input.dayTimeRegularMin;
            payload.dayTimeRegularMax = input.dayTimeRegularMax;

            payload.dayTimeMaxMin = input.dayTimeMaxMin;
            payload.dayTimeMaxMax = input.dayTimeMaxMax;

            payload.restTimeMin = input.restTimeMin;
            payload.restTimeMax = input.restTimeMax;

            payload.weekWorkDaysRegularMin = input.weekWorkDaysRegularMin;
            payload.weekWorkDaysRegularMax = input.weekWorkDaysRegularMax;

            payload.overtimeCutoffMin = input.dayTimeRegularMin;
            payload.overtimeCutoffMax = Math.max(input.dayTimeRegularMax, input.dayTimeMaxMax);

            if (input.allowMultipleShifts) {
                payload.shiftBetweenTimeMinMin = input.shiftBetweenTimeMinMin;
                payload.shiftBetweenTimeMinMax = input.shiftBetweenTimeMinMax;

                payload.shiftBetweenTimeMaxMin = input.shiftBetweenTimeMaxMin;
                payload.shiftBetweenTimeMaxMax = input.shiftBetweenTimeMaxMax;
            } else {
                payload.shiftBetweenTimeMinMin = -1;
                payload.shiftBetweenTimeMinMax = -1;

                payload.shiftBetweenTimeMaxMin = -1;
                payload.shiftBetweenTimeMaxMax = -1;
            }

            if (input.limitConsecutiveDays) {
                payload.daysConsecutiveMaxMin = input.daysConsecutiveMaxMin;
                payload.daysConsecutiveMaxMax = input.daysConsecutiveMaxMax;
            } else {
                payload.daysConsecutiveMaxMin = -1;
                payload.daysConsecutiveMaxMax = -1;
            }

            if (input.limitOvertime) {
                payload.monthOvertimeMaxMin = input.monthOvertimeMaxMin;
                payload.monthOvertimeMaxMax = input.monthOvertimeMaxMax;
            } else {
                payload.monthOvertimeMaxMin = -1;
                payload.monthOvertimeMaxMax = -1;
            }

            if (input.useWorkDaysForSpareTime) {
                payload.weekWorkDaysMaxMin = input.weekWorkDaysMaxMin;
                payload.weekWorkDaysMaxMax = input.weekWorkDaysMaxMax;
            } else {
                payload.weekWorkDaysMaxMin = -1;
                payload.weekWorkDaysMaxMax = -1;
            }

            payload.weekSpareDaysMinMin = input.weekSpareDaysMinMin;
            payload.weekSpareDaysMinMax = input.weekSpareDaysMinMax;

            payload.weekSpareTimeMinMin = input.weekSpareDaysMinMin * 24 * 60 + input.weekAdditionalSpareTime;
            payload.weekSpareTimeMinMax = input.weekSpareDaysMinMax * 24 * 60 + input.weekAdditionalSpareTime;

            payload.weekTimeAvgType = input.weekTimeAvgType;

            payload.weekSpareTimeStartType = input.weekSpareTimeStartType;
            if (payload.weekSpareTimeStartType == 1) {
                payload.weekSpareTimeStartMin = null;
                payload.weekSpareTimeStartMax = null;
            } else {
                payload.weekSpareTimeStartMin = input.weekSpareTimeStartMin.format("HH:mmZ");
                payload.weekSpareTimeStartMax = input.weekSpareTimeStartMax.format("HH:mmZ");
            }

            if (input.limitEmployeeCount) {
                payload.employeeCountMax = input.employeeCountMax;
            } else {
                payload.employeeCountMax = null;
            }

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                let templateMapItem = view.employeeTypeTemplateMap[view.templateId];
                if (templateMapItem != undefined) {
                    for (let property in payload) {
                        if (payload.hasOwnProperty(property) && templateMapItem.hasOwnProperty(property)) {
                            templateMapItem[property] = payload[property];
                        }
                    }
                }
                view.$store.commit("setEmployeeTypeTemplateMapEntry", templateMapItem);
                view.$store.commit("invalidateState", {states: ["employeeTypeMapState"]});
                view.loadingStop();
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('store.templates.planingUpdate'));
            }).catch(function (error) {
                view.loadingStop();
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.templates.planingUpdateError'));
                console.log(error)
            })
        },

        openDeletePopup: function (t) {
            let view = this;

            let dataEntries = [{
                label: this.$t('store.templates.planingDeleteQuery'),
                key: 'text',
                hidden: false,
                type: 'text',
                length: 128,
                disabled: true,
                styles: {
                    'width': '550px'
                },
                value: t.name
            }
            ];

            this.$helpers.OpenPopup({
                elRelative: null,
                type: 'datafill',
                pointerDirection: -1,
                componentState: {
                    entries: dataEntries,
                    selectCallback: function () {
                        view.deleteEmployeeTypeTemplate(t.id);
                    },
                    deleteCallback: function () {},
                    negativeButtonLabel: this.$t('global.ui.cancel'),
                    positiveButtonLabel: this.$t('global.ui.delete'),
                },
                header: this.$t('global.ui.deleteX', [this.$t('pages.employeeContract.planningEmployeeType'),]),
                remainAfterSelect: false,
                width: '700px',
                centered: true,
                expanded: true,
            });
        },
        deleteEmployeeTypeTemplate: function (templateId) {
            this.templateerror = false;
            let view = this;
            let url = '/api/sec/employeetypetemplate';

            url = this.$helpers.appendParam("id", templateId, url, '/api/sec/employeetypetemplate');
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeetypetemplate');

            this.axios({
                method: 'delete',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            }).then(response => {
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('store.templates.planingDelete'));
                view.$store.commit("deleteEmployeeTypeTemplateMapEntry", {id: templateId});
                view.$store.commit("invalidateState", {states: ["employeeTypeMapState"]});
                view.templateId = undefined;

            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.templates.planingDeleteError'));
                console.log(error)
            })

        },
        resetEmployeeTypeTemplateLimits() {
            this.templateLimits = {
                disableMonthTimeMaxType: false,
                monthTimeRegularMinLimit: 0*60,
                monthTimeRegularMaxLimit: 372*60,
                disableMonthTimeRegular: false,
                monthTimeMaxAdjustmentMinLimit: -31*12*60,
                monthTimeMaxAdjustmentMaxLimit: 31*12*60,
                disableMonthTimeMaxAdjustment: false,
                weekTimeRegularMinLimit: 0*60,
                weekTimeRegularMaxLimit: 168*60,
                disableWeekTimeRegular: false,
                weekTimeMaxMinLimit: 0*60,
                weekTimeMaxMaxLimit: 168*60,
                disableWeekTimeMax: false,
                disableWeekTimeAvgType: false,
                dayTimeRegularMinLimit: 0*60,
                dayTimeRegularMaxLimit: 24*60,
                disableDayTimeRegular: false,
                dayTimeMaxMinLimit: 0*60,
                dayTimeMaxMaxLimit: 24*60,
                disableDayTimeMax: false,
                weekWorkDaysRegularMinLimit: 0,
                weekWorkDaysRegularMaxLimit: 7,
                disableWeekWorkDaysRegular: false,
                restTimeMinLimit: 0*60,
                restTimeMaxLimit: 24*60,
                disableRestTime: false,
                weekSpareDaysMinMinLimit: 0,
                weekSpareDaysMinMaxLimit: 7,
                disableweekSpareDaysMin: false,
                weekAdditionalSpareTimeMinLimit: 0*60,
                weekAdditionalSpareTimeMaxLimit: 24*60,
                disableWeekAdditionalSpareTime: false,

            };
        },
        resetEmployeeTypeTemplateValues() {
            this.employeeTypeTemplate = {
                name: "",
                contractId: null,
                monthTimeMaxType: 1,
                monthTimeMaxAdjustmentMin: 0,
                monthTimeMaxAdjustmentMax: 0,
                weekTimeMaxMin: 60,
                weekTimeMaxMax: 60,
                weekTimeRegularMin: 40,
                weekTimeRegularMax: 40,
                dayTimeMaxMin: 12,
                dayTimeMaxMax: 12,
                dayTimeRegularMin: 8,
                dayTimeRegularMax: 8,
                restTimeMin: 11,
                restTimeMax: 11,
                allowMultipleShifts: false,
                shiftBetweenTimeMinMin: 0,
                shiftBetweenTimeMinMax: 0,
                shiftBetweenTimeMaxMin: 3,
                shiftBetweenTimeMaxMax: 3,
                limitConsecutiveDays: false,
                daysConsecutiveMaxMin: 6,
                daysConsecutiveMaxMax: 6,
                limitOvertime: false,
                monthOvertimeMaxMin: 20,
                monthOvertimeMaxMax: 20,
                overtimeCutoffMin: 480,
                overtimeCutoffMax: 480,
                useWorkDaysForSpareTime: false,
                weekWorkDaysMaxMin: 1,
                weekWorkDaysMaxMax: 1,
                weekWorkDaysRegularMin: 5,
                weekWorkDaysRegularMax: 5,
                weekSpareDaysMinMin: 1,
                weekSpareDaysMinMax: 1,
                weekAdditionalSpareTime: 12,
                weekTimeAvgType: 1,
                weekSpareTimeStartType: 1,
                weekSpareTimeStartMin: null,
                weekSpareTimeStartMax: null,
                limitEmployeeCount: false,
                employeeCountMax: null
            };

        },

        hideModal(ref) {

            this.resetEmployeeTypeTemplateValues();
            this.resetEmployeeTypeTemplateLimits();
            this.$refs[ref].hide()
        },
        showModal(ref) {
            this.$refs[ref].show()
        }
    },

}
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->

<style scoped>

</style>
